"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumManagers = void 0;
const createEnumManager_1 = require("./createEnumManager");
exports.enumManagers = {
    AccessPointType: (0, createEnumManager_1.createEnumManager)({
        COMMON_AREA: 'Common Area',
        RESTRICTED_WHITELIST: 'Restricted (Whitelist)',
        RESTRICTED_BLACKLIST: 'Restricted (Blacklist)',
        AMENITY: 'Amenity',
        RESERVATION_ONLY: 'Reservation Only',
    }),
    AccountStatus: (0, createEnumManager_1.createEnumManager)({
        ENABLED: 'Enabled',
        DISABLED: 'Disabled',
    }),
    AuthMethod: (0, createEnumManager_1.createEnumManager)({
        PHONE_NUMBER: '1FA - Phone Number',
        EMAIL: '1FA - Email',
        PHONE_NUMBER_AND_EMAIL: '2FA - Phone Number and Email',
        PHONE_NUMBER_AND_PASSWORD: '2FA - Phone Number and Password',
        EMAIL_AND_PASSWORD: '2FA - Email and Password',
        AUGUST_OAUTH: '2FA - August OAuth',
        SINGLE_SIGN_ON: 'Single Sign-On',
    }),
    CredentialType: (0, createEnumManager_1.createEnumManager)({
        FOB: 'Fob',
        MOBILE: 'Mobile',
    }),
    FailurePlan: (0, createEnumManager_1.createEnumManager)({
        FAIL_SAFE: 'Fail-Safe',
        FAIL_SECURE: 'Fail-Secure',
    }),
    GpioMode: (0, createEnumManager_1.createEnumManager)({
        INPUT: 'Input',
        OUTPUT: 'Output',
    }),
    HubActivationStatus: (0, createEnumManager_1.createEnumManager)({
        PENDING_ACTIVATION: 'Pending Activation',
        ACTIVATED: 'Activated',
        DEACTIVATED: 'Deactivated',
    }),
    HubDeviceType: (0, createEnumManager_1.createEnumManager)({
        RASPBERRY_PI: 'Raspberry Pi',
        ETHOS_EDGE_READER: 'Ethos Edge Reader',
        ETHOS_EDGE_READER_NC: 'Ethos Edge Reader N/C',
        ETHOS_EDGE_READER_NO: 'Ethos Edge Reader N/O',
        ETHOS_SECURE_SIDE_DEVICE: 'Ethos Secure-Side Device',
        ETHOS_SECURE_SIDE_DEVICE_NC: 'Ethos Secure-Side Device N/C',
        ETHOS_SECURE_SIDE_DEVICE_NO: 'Ethos Secure-Side Device N/O',
    }),
    InputDevice: (0, createEnumManager_1.createEnumManager)({
        DPS: 'Door Position Sensor (DPS)',
        REX: 'Request-to-Exit (REX)',
        INTERCOM: 'Intercom',
        AMAZON_KEY: 'Amazon Key',
        OTHER: 'Other',
    }),
    PermissionScope: (0, createEnumManager_1.createEnumManager)({
        GLOBAL: 'Global',
        ORGANIZATION: 'Organization',
        PROPERTY: 'Property',
        UNIT: 'Unit',
        ACCESS_POINT: 'Access Point',
        SMART_LOCK: 'Smart Lock',
    }),
    PropertyMapType: (0, createEnumManager_1.createEnumManager)({
        FLOOR_PLATE: 'Floor Plate',
        STACK: 'Stack',
        OBLIQUE: 'Oblique',
        ELEVATION: 'Elevation',
    }),
    ReaderType: (0, createEnumManager_1.createEnumManager)({
        KEYPAD: 'Keypad',
        NON_KEYPAD: 'Non-Keypad',
        LONG_RANGE: 'Long Range',
    }),
    SessionType: (0, createEnumManager_1.createEnumManager)({
        ACCESS_APP: 'Access App',
        ADMIN_PANEL: 'Admin Panel',
    }),
    SmartLockLogType: (0, createEnumManager_1.createEnumManager)({
        UNLOCK_VIA_APP: 'Unlock - Via App',
        UNLOCK_VIA_KEYPAD: 'Unlock - Via Keypad',
        UNLOCK_MANUAL: 'Unlock - Manual',
        LOCK_VIA_APP: 'Lock - Via App',
        LOCK_VIA_KEYPAD: 'Lock - Via Keypad',
        LOCK_VIA_AUTO_LOCK: 'Lock - Via Auto-Lock',
        LOCK_MANUAL: 'Lock - Manual',
        // The values below are not currently used
        PIN_CODE_MANAGEMENT_CREATE: 'Pin Code Management - Create',
        PIN_CODE_MANAGEMENT_DELETE: 'Pin Code Management - Delete',
        USER_MANAGEMENT_ADD: 'User Management - Add',
        USER_MANAGEMENT_REMOVE: 'User Management - Remove',
    }),
    TicketStatus: (0, createEnumManager_1.createEnumManager)({
        PENDING: 'Pending',
        SOLVED: 'Solved',
        UNSOLVED: 'Unsolved',
    }),
    TicketType: (0, createEnumManager_1.createEnumManager)({
        SMART_LOCK_LOW_BATTERY: 'Smart Lock - Low Battery',
        TURNOVER_LOCK_RESET: 'Turnover - Lock Reset',
    }),
    Timezone: (0, createEnumManager_1.createEnumManager)({
        'America/Anchorage': 'America/Anchorage (Alaska)',
        'America/Chicago': 'America/Chicago (Central)',
        'America/Denver': 'America/Denver (Mountain Daylight/Standard)',
        'America/Los_Angeles': 'America/Los_Angeles (Pacific)',
        'America/New_York': 'America/New_York (Eastern)',
        'America/Phoenix': 'America/Phoenix (Mountain Standard)',
    }),
    UnitType: (0, createEnumManager_1.createEnumManager)({
        RESIDENTIAL: 'Residential',
        STAFF: 'Staff',
    }),
    UnlockMethod: (0, createEnumManager_1.createEnumManager)({
        ACCESS_APP_FAVORITES: 'Access App - Favorites',
        ACCESS_APP_NEARBY: 'Access App - Nearby',
        ACCESS_APP_SEARCH: 'Access App - Search',
        ACCESS_WEB: 'Access Web App',
        ADMIN_PANEL: 'Admin Panel',
        CREDENTIAL_MOBILE: 'Credential - Mobile',
        CREDENTIAL_PHYSICAL: 'Credential - Physical',
        CREDENTIAL_UNKNOWN: 'Credential - Unknown',
        INPUT_DEVICE: 'Input Device',
        NFC: 'NFC',
        PIN_CODE: 'Pin Code',
        QR_CODE: 'QR Code',
        SIRI_SHORTCUT: 'Siri Shortcut',
        SMART_BUILDING_PORTAL: 'Smart Building Portal',
        SPACESHIP_MODE: 'Spaceship Mode',
        WIDGET_FAVORITES: 'Widget - Favorites',
        WIDGET_NEARBY: 'Widget - Nearby',
    }),
    UnlockResult: (0, createEnumManager_1.createEnumManager)({
        ACCESS_GRANTED: 'Access Granted',
        ACCESS_DENIED: 'Access Denied',
    }),
    UserRoleGrantMethod: (0, createEnumManager_1.createEnumManager)({
        CHIRP_ACCESS_APP: 'Chirp Access App',
        CHIRP_ADMIN_PANEL: 'Chirp Admin Panel',
        CHIRP_PMS_INTEGRATION: 'Chirp PMS Integration',
        REALPAGE_SGT: 'RealPage Self-Guided Tour',
        VIRTUAL_DIRECTORY_RESIDENT_APPROVAL: 'Virtual Directory - Resident Approval',
        VIRTUAL_DIRECTORY_STAFF_APPROVAL: 'Virtual Directory - Staff Approval',
    }),
    UserRoleReason: (0, createEnumManager_1.createEnumManager)({
        CAPITAL_PROJECT: 'Capital Project',
        DOG_WALKER: 'Dog Walker',
        EMPLOYEE_VACATION_SUITE: 'Employee Vacation Suite',
        GATEWAY_INSTALLATION: 'Gateway - Installation',
        GATEWAY_SERVICE_CALL: 'Gateway - Service Call',
        HOUSEKEEPING: 'Housekeeping',
        INSPECTION: 'Inspection',
        LAW_ENFORCEMENT: 'Law Enforcement',
        MAINTENANCE_EMERGENCY: 'Maintenance Emergency',
        PACKAGE_DROPOFF: 'Package Dropoff',
        PEST_CONTROL: 'Pest Control',
        PREVENTATIVE_MAINTENANCE: 'Preventative Maintenance',
        PROSPECT_TOUR: 'Prospect Tour',
        REPOSITION: 'Reposition',
        SERVICE_REQUEST: 'Service Request',
        SKIPS_AND_EVICTIONS: 'Skips and evictions',
        SMART_LOCK_AUGUST_CONNECT: 'Smart Lock - August Connect',
        SMART_LOCK_SYNC: 'Smart Lock - Connect and Sync Data',
        SMART_LOCK_LOW_BATTERY: 'Smart Lock - Low Battery',
        SMART_LOCK_PROVISIONING: 'Smart Lock - Provisioning',
        SMART_LOCK_TROUBLESHOOTING: 'Smart Lock - Troubleshooting',
        THIRD_PARTY_SERVICES: 'Third Party Services',
        TURNOVER_CLEAN: 'Turnover - Clean',
        TURNOVER_FLOOR_CLEAN: 'Turnover - Floor Clean',
        TURNOVER_LOCK_RESET: 'Turnover - Lock Reset',
        TURNOVER_MAINTENANCE: 'Turnover - Maintenance',
        TURNOVER_PAINT: 'Turnover - Paint',
        TURNOVER_OTHER: 'Turnover - Other',
        WELFARE_CHECK: 'Welfare Check',
        OTHER: 'Other',
    }),
    UserRoleStatus: (0, createEnumManager_1.createEnumManager)({
        PENDING: 'Pending',
        ACTIVE: 'Active',
        EXPIRED: 'Expired',
        REVOKED: 'Revoked',
    }),
};
//# sourceMappingURL=enumManagers.js.map